import { useState } from 'react'
import Socials from './Socials'

const Logo = require('../../img/drippy_rugs_logo_320x320.png')

export default function Footer() {
    const [loaded, setLoaded] = useState(false)

    const handleImgLoaded = () => setLoaded(true)

    return (
        <footer className="w-full flex flex-col items-center px-4">
            <div className="grid min-[500px]:grid-cols-2 gap-12 min-[500px]:w-full max-w-screen-md text-sm py-12">
                <section>
                    <h1 className="block w-[160px] h-[160px] hover:glow hover:animate-shake">
                        <img
                            src={Logo}
                            alt={'@drippy_rugs logo'}
                            width={160}
                            height={160}
                            className={`${
                                loaded ? 'opacity-100' : 'opacity-0'
                            } duration-200`}
                            onLoad={handleImgLoaded}
                        />
                    </h1>
                </section>

                <section>
                    <ul>
                        <li key="name">Jindřich Habarta</li>
                        <li key="phone">
                            Tel. č.:{' '}
                            <a href="tel:+420775180052" className="font-normal">
                                +420 775 180 052
                            </a>
                        </li>

                        <li key="email">
                            Email:{' '}
                            <a
                                href="mailto:jindriskuv@email.cz"
                                className="font-normal"
                            >
                                jindriskuv@email.cz
                            </a>
                        </li>
                    </ul>
                </section>

                <section>
                    <ul>
                        <li key="ico">IČO: 19684690</li>
                        <li key="dic">DIČ: CZ0209046156</li>
                    </ul>
                </section>

                <section>
                    <Socials />
                </section>
            </div>
            <span className="text-xs opacity-75 pb-4">
                Copyright &copy; 2023 Drippy Rugs. |{' '}
                <a
                    href="https://www.instagram.com/lubahabarta/"
                    target="_blank"
                    rel="noreferrer"
                >
                    @lubahabarta
                </a>
            </span>
        </footer>
    )
}
